/**
 * 入驻审核状态
 *
 * 注意：后端 /dict 接口（EnumUtil.getEnumList）以枚举「简单类名」作为字典 key，
 * UserConstant.AuditStatusEnum（1-待审核 2-审核成功 3-审核失败）与
 * HomeWorkerConstant.AuditStatusEnum（0-待审核 1-审核通过 2-审核拒绝）同名，会互相覆盖，
 * 因此本模块不使用 customDict.AuditStatusEnum，改为本地定义，保证与后端枚举一致。
 */

/** 审核状态：0-待审核 1-审核通过 2-审核拒绝 */
export const AUDIT_STATUS = {
  PENDING: 0,
  PASS: 1,
  REJECT: 2
}

/** 审核状态下拉选项（名称与后端 HomeWorkerConstant.AuditStatusEnum 保持一致） */
export const AUDIT_STATUS_OPTIONS = [
  { type: AUDIT_STATUS.PENDING, name: '待审核' },
  { type: AUDIT_STATUS.PASS, name: '审核通过' },
  { type: AUDIT_STATUS.REJECT, name: '审核拒绝' }
]

/**
 * 获取审核状态名称
 * @param {Number} type 审核状态
 */
export function getAuditStatusName(type) {
  const item = AUDIT_STATUS_OPTIONS.find(o => o.type === type)
  return item ? item.name : ''
}
